
import React from 'react';
import CustomerServiceHeader from './CustomerServiceSection/CustomerServiceHeader';
import SupportChannels from './CustomerServiceSection/SupportChannels';
import FAQSection from './CustomerServiceSection/FAQSection';

const CustomerServiceSection = () => {
  return (
    <section className="py-16 md:py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <CustomerServiceHeader />
        <SupportChannels />
        <FAQSection />
      </div>
    </section>
  );
};

export default CustomerServiceSection;
